import { createSelector } from 'reselect';
import { get } from 'lodash';
import { flatten, flow, map } from 'lodash/fp';

import positionsSelector from './positionsSelector';

export const getEntityPositionSalaryFactor = (entityPositions, entityPosition) => {
  const currentPosition = entityPositions.find(entityPos => entityPos.key === entityPosition);

  return get(currentPosition, 'factor', 1);
};

export const getFactoredEntityPositionSalary = (baseSalary, entityPositions, positionId) => {
  if (!entityPositions || !Array.isArray(entityPositions) || !positionId) return baseSalary;

  return Math.round(baseSalary * getEntityPositionSalaryFactor(entityPositions, positionId));
};

export const getFactoredEntityPositionProjection = (
  baseProjection,
  entityPositions,
  positionId
) => {
  if (!entityPositions || !Array.isArray(entityPositions) || !positionId) return baseProjection;

  return baseProjection * getEntityPositionSalaryFactor(entityPositions, positionId);
};

const getSelectionsSalary = positions => {
  const selections = flow(map('selections'), flatten)(positions);

  const salarySum = selections.reduce(
    (sum, selection) =>
      sum +
      getFactoredEntityPositionSalary(selection.salary, selection.positions, selection.positionId),
    0
  );

  return salarySum;
};

const salaryExpenditureSelector = createSelector(positionsSelector, getSelectionsSalary);

export default salaryExpenditureSelector;
